import { PageShell } from "@/components/PageShell";

const sections = [
  { h: "What we collect", p: "When you create an account or contact us we collect your name, shop/company name, email, phone number and address. When you install Xpattern we record which plan you selected and when the software was activated." },
  { h: "How we use it", p: "Your details are used to create and activate your Xpattern account, deliver vehicle updates to your profile, process your subscription and respond to support requests. We do not sell your information." },
  { h: "Payments", p: "Subscription payments are processed inside the Xpattern software by our payment provider. Xpattern never stores full card numbers on its own servers." },
  { h: "Data protection", p: "Passwords are stored hashed, never in plain text. Account data is transmitted over HTTPS and stored on access-controlled servers." },
  { h: "Your choices", p: "You can request a copy of your data, a correction or deletion of your account at any time by emailing support@xpattern.net." },
  { h: "Contact", p: "Xpattern · Portland, Oregon · support@xpattern.net · 503.328.4130" },
];

export default function Privacy() {
  return (
    <PageShell eyebrow="Legal" title="Privacy Policy & Data Protection" intro={`Last updated ${new Date().getFullYear()}. This page explains what Xpattern collects, why, and how it's protected.`} testId="privacy-page">
      <div className="mx-auto max-w-3xl space-y-8" data-testid="privacy-sections">
        {sections.map((s) => (
          <div key={s.h}>
            <h2 className="display text-2xl text-white">{s.h}</h2>
            <p className="mt-2 text-[15px] leading-relaxed text-muted">{s.p}</p>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
